// src/pages/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  loginEstablishmentAdmin,
  loginSuperAdmin,
} from '../services/api';          // 🔗 your API helpers

function Login() {
  /* ------------------------------------------------------------------ */
  /* local state                                                        */
  /* ------------------------------------------------------------------ */
  const [mode, setMode]   = useState('establishment'); // 'establishment' | 'super'
  const [estId, setEstId] = useState('');
  const [passcode, setPasscode] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');

  const navigate = useNavigate();

  /* ------------------------------------------------------------------ */
  /* submit handler                                                     */
  /* ------------------------------------------------------------------ */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (mode === 'establishment') {
        await loginEstablishmentAdmin(Number(estId), passcode);
      } else {
        await loginSuperAdmin(email, password);
      }
      /* tokens are stored by the helper—take user to dashboard */
      navigate('/');
    } catch (err) {
      console.error(err);
      setError(
        err?.response?.data?.message ||
          'Login failed — please check your credentials.'
      );
    } finally {
      setLoading(false);
    }
  };

  /* ------------------------------------------------------------------ */
  /* basic inline styles (same look-&-feel as the rest)                 */
  /* ------------------------------------------------------------------ */
  const wrapper  = { display:'flex', justifyContent:'center', alignItems:'center',
                     height:'100vh', background:'#f5f5f5' };
  const card     = { width:400, background:'#fff', borderRadius:8, padding:30,
                     boxShadow:'0 1px 5px rgba(0,0,0,0.1)' };
  const input    = { width:'100%', padding:10, marginBottom:15,
                     border:'1px solid #ccc', borderRadius:4 };
  const btn      = { width:'100%', padding:12, border:'none', borderRadius:5,
                     color:'#fff', background:'#ba00ba', cursor:'pointer' };

  /* ------------------------------------------------------------------ */
  /* render                                                              */
  /* ------------------------------------------------------------------ */
  return (
    <div style={wrapper}>
      <div style={card}>
        <h2 style={{ textAlign:'center', marginBottom:20 }}>Admin Login</h2>

        {/* toggle between Establishment-admin & Super-admin */}
        <div style={{ display:'flex', marginBottom:20 }}>
          <button
            onClick={() => setMode('establishment')}
            style={{
              flex:1,
              padding:10,
              border:'none',
              borderRadius:'5px 0 0 5px',
              background: mode==='establishment' ? '#ba00ba' : '#ddd',
              color:      mode==='establishment' ? '#fff'    : '#333',
              cursor:'pointer',
            }}
          >
            Establishment
          </button>
          <button
            onClick={() => setMode('super')}
            style={{
              flex:1,
              padding:10,
              border:'none',
              borderRadius:'0 5px 5px 0',
              background: mode==='super' ? '#ba00ba' : '#ddd',
              color:      mode==='super' ? '#fff'    : '#333',
              cursor:'pointer',
            }}
          >
            Super Admin
          </button>
        </div>

        {/* login form */}
        <form onSubmit={handleSubmit}>
          {mode === 'establishment' ? (
            <>
              <input
                type="number"
                placeholder="Establishment ID"
                value={estId}
                onChange={(e) => setEstId(e.target.value)}
                style={input}
                required
              />
              <input
                type="password"
                placeholder="Passcode"
                value={passcode}
                onChange={(e) => setPasscode(e.target.value)}
                style={input}
                required
              />
            </>
          ) : (
            <>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={input}
                required
              />
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={input}
                required
              />
            </>
          )}

          {error && <p style={{ color:'red', marginBottom:10 }}>{error}</p>}

          <button type="submit" disabled={loading} style={{ ...btn, opacity:loading?0.7:1 }}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
